import React from "react";

export default function UserManual() {
  return (
    <html key="1" lang="en">
  <head>
    <meta charSet="UTF-8" />
    <meta content="width=device-width, initial-scale=1.0" name="viewport" />
    <title>Project & BOQ Management - Complete Workflow Guide</title>
    <style
      dangerouslySetInnerHTML={{
        __html:
          "        * {            margin: 0;            padding: 0;            box-sizing: border-box;        }        body {            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);            padding: 20px;            line-height: 1.6;        }        .container {            max-width: 1200px;            margin: 0 auto;            background: white;            border-radius: 20px;            box-shadow: 0 20px 60px rgba(0,0,0,0.3);            overflow: hidden;        }        header {            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);            color: white;            padding: 40px;            text-align: center;        }        header h1 {            font-size: 2.5em;            margin-bottom: 10px;        }        header p {            font-size: 1.2em;            opacity: 0.9;        }        .content {            padding: 40px;        }        .section {            margin-bottom: 50px;        }        .section-title {            font-size: 2em;            color: #667eea;            margin-bottom: 20px;            padding-bottom: 10px;            border-bottom: 3px solid #667eea;        }        .workflow-container {            display: flex;            flex-direction: column;            gap: 20px;            margin: 30px 0;        }        .workflow-step {            display: flex;            align-items: center;            background: #f8f9fa;            border-radius: 15px;            padding: 25px;            transition: all 0.3s ease;            cursor: pointer;            border-left: 5px solid #667eea;        }        .workflow-step:hover {            transform: translateX(10px);            box-shadow: 0 5px 20px rgba(102, 126, 234, 0.3);        }        .step-number {            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);            color: white;            width: 60px;            height: 60px;            border-radius: 50%;            display: flex;            align-items: center;            justify-content: center;            font-size: 1.5em;            font-weight: bold;            margin-right: 25px;            flex-shrink: 0;        }        .step-content {            flex: 1;        }        .step-title {            font-size: 1.3em;            color: #333;            margin-bottom: 10px;            font-weight: 600;        }        .step-description {            color: #666;            line-height: 1.8;        }        .step-description ul {            margin-top: 10px;            margin-left: 20px;        }        .step-description li {            margin: 5px 0;        }        /* Diagram Styles */        .diagram {            background: #f8f9fa;            border-radius: 15px;            padding: 30px;            margin: 30px 0;            position: relative;        }        .diagram-title {            font-size: 1.3em;            color: #667eea;            margin-bottom: 20px;            text-align: center;            font-weight: 600;        }        /* Flow Diagram */        .flow-diagram {            display: flex;            flex-direction: column;            align-items: center;            gap: 15px;        }        .flow-box {            background: white;            border: 3px solid #667eea;            border-radius: 10px;            padding: 20px 30px;            min-width: 250px;            text-align: center;            font-weight: 600;            color: #333;            position: relative;            box-shadow: 0 3px 10px rgba(0,0,0,0.1);        }        .flow-box.highlight {            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);            color: white;        }        .arrow-down {            width: 0;            height: 0;            border-left: 15px solid transparent;            border-right: 15px solid transparent;            border-top: 20px solid #667eea;            margin: 5px 0;        }        /* Hierarchy Diagram */        .hierarchy-diagram {            display: flex;            flex-direction: column;            align-items: center;            gap: 30px;        }        .hierarchy-level {            display: flex;            gap: 20px;            justify-content: center;            flex-wrap: wrap;        }        .hierarchy-box {            background: white;            border: 2px solid #667eea;            border-radius: 10px;            padding: 15px 25px;            min-width: 150px;            text-align: center;            box-shadow: 0 3px 10px rgba(0,0,0,0.1);        }        .hierarchy-box.admin {            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);            color: white;            font-weight: 600;        }        .hierarchy-box.project {            background: #e3f2fd;            border-color: #2196f3;        }        .hierarchy-box.boq {            background: #f3e5f5;            border-color: #9c27b0;        }        .hierarchy-box.item {            background: #fff3e0;            border-color: #ff9800;        }        .connector {            width: 2px;            height: 20px;            background: #667eea;            margin: 0 auto;        }        /* Comparison Table */        .comparison-table {            width: 100%;            border-collapse: collapse;            margin: 20px 0;            background: white;            border-radius: 10px;            overflow: hidden;            box-shadow: 0 3px 10px rgba(0,0,0,0.1);        }        .comparison-table th {            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);            color: white;            padding: 15px;            text-align: left;            font-weight: 600;        }        .comparison-table td {            padding: 15px;            border-bottom: 1px solid #eee;        }        .comparison-table tr:hover {            background: #f8f9fa;        }        .badge {            display: inline-block;            padding: 5px 12px;            border-radius: 20px;            font-size: 0.85em;            font-weight: 600;            margin: 3px;        }        .badge-success {            background: #d4edda;            color: #155724;        }        .badge-info {            background: #d1ecf1;            color: #0c5460;        }        .badge-warning {            background: #fff3cd;            color: #856404;        }        /* Info Box */        .info-box {            background: #e3f2fd;            border-left: 5px solid #2196f3;            border-radius: 5px;            padding: 20px;            margin: 20px 0;        }        .info-box h3 {            color: #1976d2;            margin-bottom: 10px;        }        .info-box ul {            margin-left: 20px;        }        .info-box li {            margin: 5px 0;            color: #333;        }        /* Role Cards */        .role-cards {            display: grid;            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));            gap: 20px;            margin: 20px 0;        }        .role-card {            background: white;            border-radius: 10px;            padding: 25px;            box-shadow: 0 3px 15px rgba(0,0,0,0.1);            transition: transform 0.3s ease;        }        .role-card:hover {            transform: translateY(-5px);            box-shadow: 0 5px 25px rgba(0,0,0,0.15);        }        .role-card h3 {            color: #667eea;            margin-bottom: 15px;            font-size: 1.2em;        }        .role-card ul {            list-style: none;        }        .role-card li:before {            content: \"✓ \";            color: #4caf50;            font-weight: bold;            margin-right: 5px;        }        /* Process Flow Visual */        .process-flow {            display: flex;            justify-content: space-around;            align-items: center;            flex-wrap: wrap;            margin: 30px 0;            gap: 15px;        }        .process-item {            display: flex;            flex-direction: column;            align-items: center;            flex: 1;            min-width: 150px;        }        .process-circle {            width: 80px;            height: 80px;            border-radius: 50%;            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);            color: white;            display: flex;            align-items: center;            justify-content: center;            font-size: 2em;            margin-bottom: 10px;            box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);        }        .process-label {            text-align: center;            font-weight: 600;            color: #333;        }        .process-arrow {            font-size: 2em;            color: #667eea;            align-self: center;        }        @media (max-width: 768px) {            header h1 {                font-size: 1.8em;            }            .content {                padding: 20px;            }            .workflow-step {                flex-direction: column;                text-align: center;            }            .step-number {                margin-bottom: 15px;                margin-right: 0;            }            .process-arrow {                transform: rotate(90deg);                margin: 10px 0;            }        }        footer {            background: #333;            color: white;            text-align: center;            padding: 20px;            margin-top: 40px;        }    ",
      }}
    />
  </head>
  <body>
    <div className="container">
      <header>
        <h1>📊 Project & BOQ Management System</h1>
      </header>
      <div className="content">
        <div className="section">
          <h2 className="section-title">System Overview</h2>
          <div className="diagram">
            <div className="diagram-title">System Hierarchy Structure</div>
            <div className="hierarchy-diagram">
              <div className="hierarchy-level">
                <div className="hierarchy-box admin">👤 Admin / User</div>
              </div>
              <div className="connector" />
              <div className="hierarchy-level">
                <div className="hierarchy-box project">📁 Project 1</div>
                <div className="hierarchy-box project">📁 Project 2</div>
                <div className="hierarchy-box project">📁 Project 3</div>
              </div>
              <div className="connector" />
              <div className="hierarchy-level">
                <div className="hierarchy-box boq">📋 BOQ - Civil</div>
                <div className="hierarchy-box boq">📋 BOQ - Electrical</div>
                <div className="hierarchy-box boq">📋 BOQ - HVAC</div>
                <div className="hierarchy-box boq">📋 BOQ - Plumbing</div>
              </div>
              <div className="connector" />
              <div className="hierarchy-level">
                <div className="hierarchy-box item">🔧 Item 1</div>
                <div className="hierarchy-box item">🔧 Item 2</div>
                <div className="hierarchy-box item">🔧 Item 3</div>
                <div className="hierarchy-box item">🔧 Item n...</div>
              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">Complete Workflow - Step by Step</h2>
          <div className="workflow-container">
            <div className="workflow-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <div className="step-title">🔐 Login to System</div>
                <div className="step-description">
                  <p>Authorized user logs into the system with credentials.</p>
                  <ul>
                    <li>User enters username and password</li>
                    <li>System validates credentials</li>
                    <li>
                      User is redirected based on their role (Admin, Manager,
                      QS, Engineer)
                    </li>
                    <li>Dashboard shows available projects and options</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <div className="step-title">📁 Create New Project</div>
                <div className="step-description">
                  <p>
                    Admin or authorized user creates a new project with
                    essential details.
                  </p>
                  <ul>
                    <li>
                      <strong>Project Name:</strong> e.g., "ABC Mall
                      Construction"
                    </li>
                    <li>
                      <strong>Client Details:</strong> Client name, contact,
                      location
                    </li>
                    <li>
                      <strong>Project Duration:</strong> Start date and expected
                      completion
                    </li>
                    <li>
                      <strong>Budget:</strong> Overall project budget (optional)
                    </li>
                    <li>This project becomes the container for all BOQs</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <div className="step-title">
                  👥 Assign Project (Optional but Recommended)
                </div>
                <div className="step-description">
                  <p>
                    Assign project ownership and team members for better
                    control.
                  </p>
                  <ul>
                    <li>
                      <strong>Primary Owner:</strong> Assign to Project Manager
                    </li>
                    <li>
                      <strong>Team Members:</strong> Add QS, Site Engineer, or
                      other staff
                    </li>
                    <li>
                      Only assigned users can create/modify BOQs for this
                      project
                    </li>
                    <li>Improves accountability and data security</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">4</div>
              <div className="step-content">
                <div className="step-title">📋 Create BOQ Under Project</div>
                <div className="step-description">
                  <p>
                    Create separate BOQ for each trade/category under the
                    project.
                  </p>
                  <ul>
                    <li>
                      <strong>BOQ Name:</strong> e.g., "Civil Works BOQ"
                    </li>
                    <li>
                      <strong>Trade/Category:</strong> Select from: Civil,
                      Electrical, HVAC, Plumbing, MEP, etc.
                    </li>
                    <li>
                      <strong>BOQ Code:</strong> Auto-generated or manual (e.g.,
                      BOQ-CIVIL-001)
                    </li>
                    <li>Multiple BOQs can exist for one project</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">5</div>
              <div className="step-content">
                <div className="step-title">📤 Upload BOQ Document</div>
                <div className="step-description">
                  <p>
                    Upload the original BOQ document for reference and audit
                    trail.
                  </p>
                  <ul>
                    <li>Supported formats: Excel (.xlsx, .xls), PDF</li>
                    <li>Document is stored in the system permanently</li>
                    <li>Can be downloaded anytime for reference</li>
                    <li>Useful for audits and version control</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">6</div>
              <div className="step-content">
                <div className="step-title">🔧 Add BOQ Items</div>
                <div className="step-description">
                  <p>Add line items to the BOQ using one of two methods:</p>
                  <ul>
                    <li>
                      <strong>
                        Method 1 - Import from Excel (Recommended):
                      </strong>
                      <ul>
                        <li>
                          Prepare Excel file with: Item Description, Unit,
                          Quantity, Rate
                        </li>
                        <li>Upload file to the system</li>
                        <li>
                          System automatically imports and calculates totals
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Method 2 - Manual Entry:</strong>
                      <ul>
                        <li>Add each item one by one</li>
                        <li>
                          Enter: Description, Unit (sqm, cum, nos), Quantity,
                          Rate
                        </li>
                        <li>
                          System auto-calculates: Amount = Quantity × Rate
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">7</div>
              <div className="step-content">
                <div className="step-title">✅ Review BOQ</div>
                <div className="step-description">
                  <p>
                    Review all entered data for accuracy before finalization.
                  </p>
                  <ul>
                    <li>Check quantities, units, and rates</li>
                    <li>Verify item descriptions</li>
                    <li>Review calculated totals (item-wise and overall)</li>
                    <li>Make corrections if needed</li>
                    <li>Add notes or remarks if required</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">8</div>
              <div className="step-content">
                <div className="step-title">✍️ BOQ Approval</div>
                <div className="step-description">
                  <p>Set the BOQ status based on approval workflow:</p>
                  <ul>
                    <li>
                      <span className="badge badge-warning">Draft</span> - BOQ
                      is being prepared, can be edited
                    </li>
                    <li>
                      <span className="badge badge-info">Submitted</span> - BOQ
                      sent for review/approval
                    </li>
                    <li>
                      <span className="badge badge-success">Approved</span> -
                      BOQ is finalized and ready to use
                    </li>
                    <li>
                      Status can be changed based on organizational workflow
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="workflow-step">
              <div className="step-number">9</div>
              <div className="step-content">
                <div className="step-title">📊 BOQ Usage</div>
                <div className="step-description">
                  <p>
                    Once approved, BOQ is used for various project activities:
                  </p>
                  <ul>
                    <li>
                      <strong>Cost Reference:</strong> Track actual vs budgeted
                      costs
                    </li>
                    <li>
                      <strong>Project Tracking:</strong> Monitor work progress
                      against BOQ
                    </li>
                    <li>
                      <strong>RA Bills:</strong> Generate Running Account bills
                      based on completed work
                    </li>
                    <li>
                      <strong>Reports:</strong> Generate various cost and
                      progress reports
                    </li>
                    <li>
                      <strong>Variations:</strong> Track change orders and
                      variations
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">Quick Process Flow</h2>
          <div className="diagram">
            <div className="flow-diagram">
              <div className="flow-box highlight">Login to System</div>
              <div className="arrow-down" />
              <div className="flow-box">Create Project</div>
              <div className="arrow-down" />
              <div className="flow-box">Assign Team (Optional)</div>
              <div className="arrow-down" />
              <div className="flow-box">Create BOQ</div>
              <div className="arrow-down" />
              <div className="flow-box">Upload BOQ Document</div>
              <div className="arrow-down" />
              <div className="flow-box">Add BOQ Items (Import/Manual)</div>
              <div className="arrow-down" />
              <div className="flow-box">Review & Verify</div>
              <div className="arrow-down" />
              <div className="flow-box">Set Status & Approve</div>
              <div className="arrow-down" />
              <div className="flow-box highlight">
                Use BOQ for Project Tracking
              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">Project Assignment Options</h2>
          <table className="comparison-table">
            <thead>
              <tr>
                <th>Feature</th>
                <th>Option 1: Without Assignment</th>
                <th>Option 2: With Assignment (Recommended)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Who Can Access?</strong>
                </td>
                <td>All authorized users in the system</td>
                <td>Only assigned team members</td>
              </tr>
              <tr>
                <td>
                  <strong>Who Can Create BOQ?</strong>
                </td>
                <td>Anyone with access</td>
                <td>Only Project Manager or assigned users</td>
              </tr>
              <tr>
                <td>
                  <strong>Who Can Modify BOQ?</strong>
                </td>
                <td>Anyone with access</td>
                <td>Only assigned team members</td>
              </tr>
              <tr>
                <td>
                  <strong>Data Security</strong>
                </td>
                <td>Lower - Open access</td>
                <td>Higher - Controlled access</td>
              </tr>
              <tr>
                <td>
                  <strong>Accountability</strong>
                </td>
                <td>Difficult to track who made changes</td>
                <td>Clear ownership and responsibility</td>
              </tr>
              <tr>
                <td>
                  <strong>Best For</strong>
                </td>
                <td>
                  <span className="badge badge-info">Small teams</span>
                  <span className="badge badge-info">Demo phase</span>
                  <span className="badge badge-info">Pilot projects</span>
                </td>
                <td>
                  <span className="badge badge-success">Production use</span>
                  <span className="badge badge-success">Large teams</span>
                  <span className="badge badge-success">Multiple projects</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="info-box">
            <h3>💡 Recommendation</h3>
            <p>
              Use <strong>Option 2 (With Assignment)</strong> for better
              control, security, and accountability. This ensures:
            </p>
            <ul>
              <li>
                Only authorized personnel can modify critical project data
              </li>
              <li>Clear ownership of each project</li>
              <li>Better audit trail for changes</li>
              <li>Reduced risk of data errors or unauthorized changes</li>
            </ul>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">User Roles & Permissions</h2>
          <div className="role-cards">
            <div className="role-card">
              <h3>👑 Admin</h3>
              <ul>
                <li>Create and manage all projects</li>
                <li>Add and manage users</li>
                <li>Assign projects to team members</li>
                <li>View all BOQs and reports</li>
                <li>System configuration</li>
              </ul>
            </div>
            <div className="role-card">
              <h3>👨‍💼 Project Manager</h3>
              <ul>
                <li>Manage assigned projects</li>
                <li>Create and approve BOQs</li>
                <li>Assign team members to project</li>
                <li>Generate reports</li>
                <li>Track project progress</li>
              </ul>
            </div>
            <div className="role-card">
              <h3>📐 Quantity Surveyor (QS)</h3>
              <ul>
                <li>Create and edit BOQs</li>
                <li>Import BOQ items from Excel</li>
                <li>Verify quantities and rates</li>
                <li>Generate cost reports</li>
                <li>Track variations</li>
              </ul>
            </div>
            <div className="role-card">
              <h3>👷 Site Engineer</h3>
              <ul>
                <li>View assigned project BOQs</li>
                <li>Update work progress</li>
                <li>Add field notes</li>
                <li>Generate progress reports</li>
                <li>Request BOQ changes</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">BOQ Item Entry Methods</h2>
          <div className="diagram">
            <div className="diagram-title">Choose Your Method</div>
            <div className="process-flow">
              <div className="process-item">
                <div className="process-circle">📊</div>
                <div className="process-label">
                  Import from Excel
                  <br />
                  <small>(Fast & Recommended)</small>
                </div>
              </div>
              <div className="process-arrow">→</div>
              <div className="process-item">
                <div className="process-circle">✍️</div>
                <div className="process-label">
                  Manual Entry
                  <br />
                  <small>(For small BOQs)</small>
                </div>
              </div>
            </div>
          </div>
          <div className="info-box">
            <h3>📊 Method 1: Import from Excel (Recommended)</h3>
            <p>
              <strong>Steps:</strong>
            </p>
            <ul>
              <li>
                Prepare Excel file with columns: Item No, Description, Unit,
                Quantity, Rate
              </li>
              <li>Save as .xlsx or .xls format</li>
              <li>Click "Import from Excel" button in BOQ screen</li>
              <li>Select your file and upload</li>
              <li>System automatically reads and calculates totals</li>
              <li>Review imported items and confirm</li>
            </ul>
            <p>
              <strong>Benefits:</strong> Fast, accurate, handles large BOQs
              (100+ items) easily
            </p>
          </div>
          <div
            className="info-box"
            style={{
              background: "#fff3cd",
              borderColor: "#ffc107",
            }}>
            <h3
              style={{
                color: "#856404",
              }}>
              ✍️ Method 2: Manual Entry
            </h3>
            <p>
              <strong>Steps:</strong>
            </p>
            <ul>
              <li>Click "Add New Item" button</li>
              <li>Enter Item Description (e.g., "Cement Concrete 1:2:4")</li>
              <li>Select Unit (sqm, cum, nos, kg, etc.)</li>
              <li>Enter Quantity (e.g., 150.50)</li>
              <li>Enter Rate per unit (e.g., 5000.00)</li>
              <li>System auto-calculates Amount = Quantity × Rate</li>
              <li>Click Save and repeat for each item</li>
            </ul>
            <p>
              <strong>Best For:</strong> Small BOQs with less than 20 items
            </p>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">
            Example Scenario: Real Project Setup
          </h2>
          <div className="workflow-step">
            <div className="step-number">📋</div>
            <div className="step-content">
              <div className="step-title">Project: ABC Mall Construction</div>
              <div className="step-description">
                <p>
                  <strong>Project Details:</strong>
                </p>
                <ul>
                  <li>
                    <strong>Project Name:</strong> ABC Mall Construction
                  </li>
                  <li>
                    <strong>Client:</strong> ABC Developers Pvt Ltd
                  </li>
                  <li>
                    <strong>Duration:</strong> Jan 2026 - Dec 2026 (12 months)
                  </li>
                  <li>
                    <strong>Budget:</strong> ₹50,00,00,000
                  </li>
                </ul>
                <p>
                  <strong>Project Team Assignment:</strong>
                </p>
                <ul>
                  <li>
                    <strong>Project Manager:</strong> Mr. Rajesh Kumar
                  </li>
                  <li>
                    <strong>QS:</strong> Mr. Amit Sharma
                  </li>
                  <li>
                    <strong>Site Engineer:</strong> Mr. Vikram Singh
                  </li>
                </ul>
                <p>
                  <strong>BOQs Created:</strong>
                </p>
                <ul>
                  <li>
                    <strong>BOQ 1:</strong> Civil Works - 250 items - ₹30 Crores
                  </li>
                  <li>
                    <strong>BOQ 2:</strong> Electrical Works - 180 items - ₹8
                    Crores
                  </li>
                  <li>
                    <strong>BOQ 3:</strong> HVAC - 120 items - ₹7 Crores
                  </li>
                  <li>
                    <strong>BOQ 4:</strong> Plumbing & Sanitary - 95 items - ₹5
                    Crores
                  </li>
                </ul>
                <p>
                  <strong>Workflow:</strong>
                </p>
                <ul>
                  <li>Admin creates project and assigns team</li>
                  <li>QS creates all 4 BOQs</li>
                  <li>QS uploads original BOQ Excel files</li>
                  <li>QS imports items from Excel (fast method)</li>
                  <li>Project Manager reviews and approves BOQs</li>
                  <li>Site Engineer uses BOQs for tracking progress</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">Key Benefits of the System</h2>
          <div className="role-cards">
            <div className="role-card">
              <h3>⚡ Efficiency</h3>
              <ul>
                <li>Import 100+ items in seconds</li>
                <li>Auto-calculation of totals</li>
                <li>No manual errors</li>
              </ul>
            </div>
            <div className="role-card">
              <h3>🔒 Security</h3>
              <ul>
                <li>Role-based access control</li>
                <li>Project-level permissions</li>
                <li>Audit trail for all changes</li>
              </ul>
            </div>
            <div className="role-card">
              <h3>📊 Accuracy</h3>
              <ul>
                <li>Automated calculations</li>
                <li>Data validation checks</li>
                <li>Original document storage</li>
              </ul>
            </div>
            <div className="role-card">
              <h3>📈 Tracking</h3>
              <ul>
                <li>Real-time project status</li>
                <li>Cost vs budget monitoring</li>
                <li>Progress reporting</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="section">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="info-box">
            <h3>❓ Can I create multiple BOQs for one project?</h3>
            <p>
              <strong>Answer:</strong> Yes! You can create separate BOQs for
              Civil, Electrical, HVAC, Plumbing, or any other trade. This helps
              in better organization and tracking.
            </p>
          </div>
          <div className="info-box">
            <h3>❓ What happens if I don't assign a project to anyone?</h3>
            <p>
              <strong>Answer:</strong> All authorized users will be able to see
              and modify the project. This is okay for small teams or demo
              purposes, but not recommended for production use.
            </p>
          </div>
          <div className="info-box">
            <h3>❓ Can I edit BOQ items after approval?</h3>
            <p>
              <strong>Answer:</strong> Yes, but it depends on your system
              settings. Usually, approved BOQs can be edited by Project Manager
              or Admin only, and changes are logged.
            </p>
          </div>
          <div className="info-box">
            <h3>❓ What Excel format should I use for importing BOQ items?</h3>
            <p>
              <strong>Answer:</strong> Use a simple Excel file with these
              columns: Item No, Description, Unit, Quantity, Rate. The system
              will calculate Amount automatically.
            </p>
          </div>
          <div className="info-box">
            <h3>❓ Is the original BOQ document mandatory?</h3>
            <p>
              <strong>Answer:</strong> It's optional but highly recommended. It
              serves as a reference and helps during audits or disputes.
            </p>
          </div>
        </div>
      </div>
      <footer>
        <p>© HTCL Technologies Pvt Ltd</p>
      </footer>
    </div>
    <script
      dangerouslySetInnerHTML={{
        __html:
          "        // Add smooth scrolling        document.querySelectorAll('a[href^=\"#\"]').forEach(anchor => {            anchor.addEventListener('click', function (e) {                e.preventDefault();                document.querySelector(this.getAttribute('href')).scrollIntoView({                    behavior: 'smooth'                });            });        });        // Add animation on scroll        const observerOptions = {            threshold: 0.1,            rootMargin: '0px 0px -50px 0px'        };        const observer = new IntersectionObserver((entries) => {            entries.forEach(entry => {                if (entry.isIntersecting) {                    entry.target.style.opacity = '1';                    entry.target.style.transform = 'translateY(0)';                }            });        }, observerOptions);        document.querySelectorAll('.workflow-step, .role-card, .info-box').forEach(el => {            el.style.opacity = '0';            el.style.transform = 'translateY(20px)';            el.style.transition = 'all 0.5s ease';            observer.observe(el);        });        // Print functionality        function printPage() {            window.print();        }    ",
      }}
    />
  </body>
</html>
  );
}